<template>
  <div class="ushk-rili_list">
    <economics-list v-if="active === 'economics'" :datas="economicsDatas"></economics-list>
    <economics-list v-if="active === 'stockAfter'" :datas="stockAfter" none-text="今日无股票财报数据"></economics-list>
    <economics-list v-if="active === 'stockPre'" :datas="stockPre" none-text="今日无股票财报数据"></economics-list>
    <economics-list v-if="active === 'stockHk'" :datas="stockHk" none-text="今日无股票财报数据"></economics-list>
    <events-list v-if="active === 'events'" :datas="eventsDatas"></events-list>
    <holiday-list v-if="active === 'holiday'" :datas="holidayDatas"></holiday-list>
  </div>
</template>
<script>
  import EconomicsList from './EconomicsList'
  import EventsList from './EventsList'
  import HolidayList from './HolidayList'
  export default {
    components: {
      EconomicsList,
      EventsList,
      HolidayList
    },
    props: {
      economicsDatas: {
        type: [Array, Boolean],
        default: false
      },
      eventsDatas: {
        type: [Array, Boolean],
        default: false
      },
      stockPre: {
        type: [Array, Boolean],
        default: false
      },
      stockAfter: {
        type: [Array, Boolean],
        default: false
      },
      stockHk: {
        type: [Array, Boolean],
        default: false
      },
      holidayDatas: {
        type: [Array, Boolean],
        default: false
      },
      active: {
        type: String,
        default: 'economics'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?3776d33c